import { dc, dcSoft } from "../hooks/tokens.js";

// Palette de recherche (⌘K) : requête, résultats classés par pertinence
// (voir useCore.results), aperçu de l'élément survolé.
export function buildSearchView(ctx) {
  const { s, patch, inputRef, openSearch, go, goCourse, course, moduleIdx, curModule, doneCount, lessonsData, res, all, hovered } = ctx;
  return {
    openSearch,
    closeSearch: () => patch({ searchOpen: false }),
    stop: (e) => e.stopPropagation(),
    searchOpen: s.searchOpen,
    inputRef,
    query: s.query,
    onQuery: (e) => patch({ query: e.target.value, hoverId: null }),
    resultCount: all.length > res.length ? res.length + " sur " + all.length + " résultats" : all.length + " résultat" + (all.length > 1 ? "s" : ""),
    noResults: all.length === 0,
    resultGroups: [
      { name: "Fiches", items: res.map((a) => ({
        title: a.title, meta: a.domain, dot: dc(a.domain), metaColor: dc(a.domain),
        bg: (hovered.id === a.id ? dcSoft(a.domain) : "transparent"),
        onClick: () => go(a.id), onHover: () => patch({ hoverId: a.id }),
      })) },
      { name: "Cours", items: [{ title: "Module " + (moduleIdx + 1) + " — " + curModule.title, meta: Math.round((doneCount / lessonsData.length) * 100) + " % fait",
        dot: dc("Automatisation"), metaColor: dc("Automatisation"), bg: "transparent",
        onClick: () => goCourse(course.id), onHover: () => {} }] },
    ],
    preview: { title: hovered.title, summary: hovered.summary, snippet: hovered.snippet,
      path: "wiki / " + hovered.domain.toLowerCase() + " / " + hovered.short.toLowerCase() },
    onKeyDown: (e) => {
      // Focus trap: the text input is the only focusable control inside
      // the palette today (results/preview are plain divs, not tabbable),
      // so trapping Tab just keeps focus on it rather than letting it
      // escape into the page behind the modal.
      if (e.key === "Tab") { e.preventDefault(); return; }
      if (!res.length) return;
      const i = Math.max(0, res.findIndex((a) => a.id === hovered.id));
      if (e.key === "ArrowDown") { e.preventDefault(); patch({ hoverId: res[Math.min(res.length - 1, i + 1)].id }); }
      else if (e.key === "ArrowUp") { e.preventDefault(); patch({ hoverId: res[Math.max(0, i - 1)].id }); }
      else if (e.key === "Enter") { e.preventDefault(); go(res[i].id); }
    },
  };
}
